import { Component, Input, OnInit , ViewChild} from '@angular/core';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import { TermsDialogComponent } from './terms-dialog/terms-dialog.component';
import { TermsService } from './services/terms.service';
import {NgbActiveModal, NgbModal, NgbModalRef} from '@ng-bootstrap/ng-bootstrap';
import { Router } from '@angular/router';
import { MessageService } from 'primeng/api';
import { TermsAndConditionSaveBean } from './model/termsAndConditionSaveBean';
import { DynamicDialogRef,DialogService } from 'primeng/dynamicdialog';
import { AuthenticationService } from '../core/services/authentication.service';
import { TermsConditionBean } from './model/termsConditionBean';

@Component({
  //selector: 'app-consent-dialog',
  templateUrl: './consent-dialog.component.html',
  styleUrls: ['./consent-dialog.component.css'],
})
export class ConsentDialogComponent implements OnInit {
 //CR183 FK-11 User’s consent for registraion.

  @ViewChild(TermsDialogComponent) termsComponent!: TermsDialogComponent;
  termsAndCondition: any;
  public form: FormGroup;
  rejectReasonValue: any;
  termsString: string;
  termsUuid: string;
  isAccepted= false;
  status: string;
  termsStatusToShow: string;
  termsValidity: Date;
  enableRejectReason = false;
  isAfviseEnable: boolean = false;
  isGemEnable: boolean = true;
  isDataAvailable: boolean = true;

  constructor(protected termsService: TermsService,
    private dialogService: DialogService, 
    private authenticationService: AuthenticationService,
    public ref: DynamicDialogRef,
    protected builder: FormBuilder,
    private messageService: MessageService,
    private router: Router) { 
  }

  ngOnInit(): void {

    this.authenticationService.getTermsStatusForModule().subscribe((newstatus)=>{
      if(newstatus == "REJECTED")
        this.termsStatusToShow = "Vilkår og betingelser skal være accepteret, før applikationen kan anvendes";
      else if(newstatus == "EXPIRED")
        this.termsStatusToShow = "Accept af vilkår og betingelser er udløbet. Vilkår og betingelser skal accepteres igen";
      else if(newstatus == "NEW_TERMS")
        this.termsStatusToShow = "Vilkår og betingelser er opdateret og skal accepteres igen.";
    });
    
    this.termsService.getTermsAndCondition().then(terms => {
      if(terms)
      {
        this.termsValidity = terms.validFrom!;
        this.termsString = terms.termsOfUse!;
        this.termsUuid = terms.termsOfUseUUID!;
        this.termsAndCondition = terms;
        this.termsService.setTermsData(this.termsAndCondition);
        this.isDataAvailable = true;
      }
      else{
        this.isDataAvailable = false;
        this.isAfviseEnable = true;
        this.isGemEnable = true;
        this.messageService.add({
          severity: 'error',
          summary: 'Error',
          detail: 'Ups, der opstod en uforudset fejl',
          life: 3000,
        });
      }
    });
  }

  showTermsDialog()
  {
    const ref = this.dialogService.open(TermsDialogComponent,{
      header: "Indsamling og behandling af dine personoplysninger",
      data: this.termsAndCondition,
      closable: false,
      width: '40%'
    });
  }

  termsAcceptedOrRejected(event: any)
  {
    if(event.target.checked==true && this.isDataAvailable == true){
      this.isAccepted = true;
      this.enableRejectReason = false;
      this.isGemEnable = false;
      this.isAfviseEnable = true;
    }
    else if(this.isDataAvailable == false){
      this.isGemEnable = true;
      this.isAfviseEnable = true;
    }
    else{
      this.isAccepted = false;
      this.isGemEnable = true;
      this.isAfviseEnable = false;
    }
  }

  onReject(event: Event)
  {
    if(this.isAccepted) {
        this.enableRejectReason = false;
    }
    else if(this.enableRejectReason == true) { 
        this.status = "REJECTED";
        let rejectData = new TermsAndConditionSaveBean(this.termsUuid,this.termsValidity,this.status);
        this.termsService.updateTermsAndCondition(rejectData).then((response)=>{
          event.preventDefault();
          this.closeTermsAndCondition(this.status);
        }).catch((error)=>{
          console.log(error);
          event.preventDefault();
          this.closeTermsAndCondition("serverdown");
        });
    }
    else {
      this.enableRejectReason = true;
    }
        
  }

  onSave(event: Event)
  {
    if(this.isAccepted == true && this.enableRejectReason == false)
    {
        this.status = "ACCEPTED";
        let AcceptedData = new TermsAndConditionSaveBean(this.termsUuid,this.termsValidity,this.status);
        this.termsService.updateTermsAndCondition(AcceptedData).then((response)=>{
          event.preventDefault();
          this.closeTermsAndCondition(this.status);
        }).catch((error)=>{
          console.log(error);
          event.preventDefault();
          this.closeTermsAndCondition("serverdown");
        });
    }
  }
  
  closeTermsAndCondition(status: string)
  {
    this.ref.close({
      result: status
    })
  }
}